<app-page-header subtitle="Verlof & verzuim"> </app-page-header>
@if (form) {
    <div class="container-xl">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Soort</mat-label>
                            <mat-select [formControl]="form.controls.hourtype" placeholder="Soort">
                                @if (!form.value.id || form.value.hourtype !== RealisationHourtype.zzp_leave) {
                                    @for (hourType of leaveHourTypes; track hourType.value) {
                                        <mat-option [value]="hourType.value">{{ hourType.label }}</mat-option>
                                    }
                                }
                                @if (!form.value.id || form.value.hourtype === RealisationHourtype.zzp_leave) {
                                    <mat-option [value]="RealisationHourtype.zzp_leave">
                                        ZZP niet beschikbaar
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-error [control]="form.controls.hourtype"></mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-auto d-flex align-items-center">
                        <mat-checkbox [formControl]="form.controls.common"> Bedrijfsbreed </mat-checkbox>
                    </div>
                    <mat-form-field class="col">
                        <input [formControl]="form.controls.comment" type="text" matInput placeholder="Opmerking" />
                        <mat-error [control]="form.controls.comment"></mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <div class="col">
                        @if (!form.getRawValue().common) {
                            <ng-select
                                class="ng-select-fill"
                                [formControl]="form.controls.users"
                                [items]="users"
                                [clearSearchOnAdd]="true"
                                [clearable]="true"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Medewerkers"
                                bindLabel="name"
                                bindValue="id">
                                <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                    {{ item.name }}
                                    @if (item.enddate) {
                                        <small class="text-red">
                                            Uit dienst per {{ item.enddate | date: 'dd MMMM yyyy' }}
                                        </small>
                                    }
                                </ng-template>
                                <ng-template ng-notfound-tmp>
                                    @if (form.value.hourtype) {
                                        <div class="ng-option disabled">Geen items gevonden</div>
                                    }
                                    @if (!form.value.hourtype) {
                                        <div class="ng-option disabled">Kies eerst een verlofsoort</div>
                                    }
                                </ng-template>
                            </ng-select>
                        }
                        @if (form.getRawValue().common) {
                            <ng-select
                                class="ng-select-fill"
                                [formControl]="form.controls.excludedUsers"
                                [items]="users"
                                [clearable]="true"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Uitgesloten medewerkers"
                                bindLabel="name"
                                bindValue="id">
                            </ng-select>
                        }
                    </div>
                </div>
                <div class="row">
                    @if (!form.value.interval) {
                        <div class="col-24 col-md-8">
                            <b>Datum</b>
                            <div>
                                <mat-form-field>
                                    <input
                                        [min]="minDate"
                                        [matDatepicker]="pickerStart"
                                        [formControl]="form.controls.begindate"
                                        (focus)="pickerStart.open()"
                                        matInput
                                        placeholder="Datum" />
                                    <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #pickerStart></mat-datepicker>
                                    <mat-error [control]="form.controls.begindate"></mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    }
                    @if (form.value.interval) {
                        <div class="col-24">
                            <b>
                                Periode
                                <i
                                    class="fa fa-info-circle"
                                    matTooltipPosition="above"
                                    matTooltip="De periode waarbinnen herhaalt wordt.
                           Als de begintijd van de periode later is dan de begintijd bij 'Tijden', is op de eerste dag de begintijd van de periode leidend. Vice versa voor eindtijd."></i>
                            </b>
                            <div class="row">
                                <div class="col">
                                    <app-datetime-input
                                        [formControl]="form.controls.begindate"
                                        [min]="minDate"
                                        [matFormField]="true"
                                        labelDate="Begindatum"
                                        labelTime="tijd"></app-datetime-input>
                                    <mat-error [control]="form.controls.begindate"></mat-error>
                                </div>
                                <div class="col">
                                    <app-datetime-input
                                        [formControl]="form.controls.enddate"
                                        [min]="form.controls.begindate.value"
                                        [max]="maxDate"
                                        [matFormField]="true"
                                        labelDate="Einddatum"
                                        labelTime="tijd"></app-datetime-input>
                                    <mat-error [control]="form.controls.enddate"></mat-error>
                                </div>
                            </div>
                        </div>
                    }
                    <div class="col-12">
                        <b>
                            {{ form.value.interval ? 'Tijden' : 'Tijd' }}
                            @if (form.value.interval) {
                                <i
                                    class="fa fa-info-circle"
                                    matTooltipPosition="above"
                                    matTooltip="De tijd op de dag zelf.
                           Als de begintijd onder 'Periode' later is is dan deze begintijd, is op de eerste dag de begintijd van de periode leidend. Vice versa voor eindtijd."></i>
                            }
                        </b>
                        <div class="row">
                            <div class="col-12">
                                <app-datetime-input
                                    [formControl]="form.controls.begintime"
                                    [hideDate]="true"
                                    [matFormField]="true"
                                    labelDate="Begindatum"
                                    labelTime="tijd"></app-datetime-input>
                                <mat-error [control]="form.controls.begintime"></mat-error>
                            </div>
                            <div class="col-12">
                                <app-datetime-input
                                    [formControl]="form.controls.endtime"
                                    [hideDate]="true"
                                    [matFormField]="true"
                                    labelDate="Einddatum"
                                    labelTime="tijd"></app-datetime-input>
                                <mat-error [control]="form.controls.endtime"></mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 d-flex align-items-center">Duur: {{ duration | minutes }} uur</div>
                </div>
                <div class="row">
                    <div class="col-auto d-flex align-items-center">
                        <mat-checkbox [formControl]="form.controls.interval"> Herhalend </mat-checkbox>
                    </div>
                    @if (form.value.interval) {
                        <mat-form-field class="col">
                            <input
                                [formControl]="form.controls.interval_week"
                                appDecimalInput
                                matInput
                                placeholder="Week interval"
                                type="text" />
                            <mat-error [control]="form.controls.interval_week"></mat-error>
                        </mat-form-field>
                    }
                </div>
                @if (form.value.interval) {
                    <div>
                        <mat-checkbox
                            [formControl]="form.controls.close_period"
                            color="primary"
                            matTooltip="Deze optie zorgt ervoor dat in deze periode alle dagen in de planning worden dichtgezet, vanaf de begindatum t/m de einddatum ongeacht de aangevinkte dagen en uitzonderingen.">
                            Periode dichtzetten
                        </mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox
                            [indeterminate]="allIndeterminate"
                            [checked]="allChecked"
                            (change)="toggleAll()"
                            color="primary"
                            >Alle</mat-checkbox
                        >
                        <div class="ms-4">
                            <mat-checkbox [formControl]="form.controls.repeat_monday" color="primary"
                                >Maandag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_tuesday" color="primary"
                                >Dinsdag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_wednesday" color="primary"
                                >Woensdag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_thursday" color="primary"
                                >Donderdag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_friday" color="primary"
                                >Vrijdag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_saturday" color="warn"
                                >Zaterdag</mat-checkbox
                            >
                            <br />
                            <mat-checkbox [formControl]="form.controls.repeat_sunday" color="warn">Zondag</mat-checkbox>
                        </div>
                    </div>
                }
            </div>
            <div class="col-md-6 results-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Resulterende datums</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (preview of previewRealisations; track preview) {
                            <tr>
                                <td class="text-right">
                                    {{ preview.begindate | date: 'EEE d MMM yyyy HH:mm' }} tot
                                    {{ preview.enddate | date: 'HH:mm' }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}

@if (previewRealisations && form && (form?.value?.excludedUsers?.length || form?.value?.users?.length)) {
    <div class="container-fluid mt-2">
        <div class="d-flex justify-content-center">
            <div class="excluded-users">
                <table class="table" (mouseout)="highlight = null">
                    <tr (mouseout)="highlight = null">
                        <th class="name-column">
                            <b>Uitsluitingen</b>
                        </th>
                        @for (preview of previewRealisations; track preview) {
                            <th
                                class="date"
                                (mouseover)="mouseOverDate(preview.begindate)"
                                (click)="excludeDate(preview.begindate)">
                                <div>
                                    {{ preview.begindate | date: 'EEE d MMM yyyy' }}
                                </div>
                            </th>
                        }
                    </tr>
                    @for (
                        user of form.getRawValue()?.common
                            ? (users | whereIn: form?.value?.excludedUsers ?? [])
                            : (users | whereIn: form?.value?.users ?? []);
                        track user
                    ) {
                        <tr>
                            <td class="name-column" (click)="excludeUser(user.id)" (mouseover)="mouseOverUser(user.id)">
                                {{ user.name }}
                            </td>
                            @for (preview of previewRealisations; track preview) {
                                <td
                                    class="check date-{{ preview.begindate | date: 'yyyy-MM-dd' }} user-{{ user.id }}"
                                    [class.highlight]="
                                        highlight === (preview.begindate | date: 'yyyy-MM-dd') || highlight === user.id
                                    "
                                    (click)="setExclude(user.id, preview.begindate)">
                                    @if (excluded.has(user.id | excludedKey: preview.begindate)) {
                                        <i class="fa-duotone fa-user-slash"></i>
                                    }
                                    @if (
                                        roosterMap.size &&
                                        !roosterMap.has(user.afas_employee_id | excludedKey: preview.begindate)
                                    ) {
                                        <i
                                            class="fa-regular fa-user-slash"
                                            [matTooltipShowDelay]="0"
                                            matTooltip="Geen werkdag voor {{ user.name }}"></i>
                                    }
                                </td>
                            }
                        </tr>
                    }
                </table>
            </div>
        </div>
    </div>
}

@if (realisations?.length > 0) {
    <div class="container-xl mt-2">
        <div class="d-flex justify-content-center">
            <div class="excluded-users">
                <table class="table table-striped table-hover realisations">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Datum</th>
                            <th>Tijd</th>
                            <th>Medewerker</th>
                            <th>Aangepast</th>
                            <th>Ingediend</th>
                            <th>Goedgekeurd</th>
                            @if (Features.RealisationHistory | hasFeature) {
                                <th><i class="fas fa-history"></i></th>
                            }
                            @if (Functionalities.CommonHourCheck | hasFunctionality) {
                                <th><i class="fas fa-user-pen"></i></th>
                            }
                        </tr>
                    </thead>
                    @for (realisation of realisations; track realisation) {
                        <tr [class.removed]="realisation.removed">
                            <td>{{ realisation.id }}</td>
                            <td>{{ realisation.begindate | date: 'EEE d MMM yyyy' }}</td>
                            <td>
                                {{ realisation.begindate | date: 'HH:mm' }} - {{ realisation.enddate | date: 'HH:mm' }}
                            </td>
                            <td>{{ realisation.user?.name }}</td>
                            <td>{{ realisation.adjusted | date: 'EEE d MMM yyyy HH:mm' }}</td>
                            <td>{{ realisation.submitted | date: 'EEE d MMM yyyy HH:mm' }}</td>
                            <td>{{ realisation.approved | date: 'EEE d MMM yyyy HH:mm' }}</td>
                            @if (Features.RealisationHistory | hasFeature) {
                                <td class="text-center">
                                    <button
                                        class="planning-button"
                                        (click)="realisationHistory(realisation)"
                                        mat-icon-button
                                        color="primary">
                                        <i class="fas fa-history"></i>
                                    </button>
                                </td>
                            }
                            @if (Functionalities.CommonHourCheck | hasFunctionality) {
                                <td>
                                    <button
                                        class="hour-edit-button"
                                        (click)="editHours(realisation.bookdate, realisation.user_id)"
                                        mat-icon-button
                                        color="primary">
                                        <i class="fa-regular fa-user-pen"></i>
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                </table>
            </div>
        </div>
    </div>
}

<div class="button-wrapper">
    <div class="container-xl">
        @if (form) {
            <div class="buttons">
                <button mat-raised-button color="accent" routerLink="/leave">Naar overzicht</button>
                @if (Features.LeaveSave | hasFeature) {
                    <button [disabled]="!form.dirty" (click)="save()" mat-raised-button color="primary">
                        {{
                            saved
                                ? 'Wijzigingen opgeslagen'
                                : form.dirty
                                  ? 'Openstaande wijzigingen opslaan'
                                  : 'Er zijn geen wijzigingen'
                        }}
                        @if (saving) {
                            <i class="fas fa-spinner fa-spin"></i>
                        }
                    </button>
                }
            </div>
        }
    </div>
</div>
